module.exports = {
        srcSet: __webpack_public_path__ + "static/media/calendar-400.47bc5c21.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/calendar-400.47bc5c21.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/calendar-400.47bc5c21.webp",
        toString: function(){return __webpack_public_path__ + "static/media/calendar-400.47bc5c21.webp"},
        
        width: 400,
        height: 400
      }